import React, { useCallback, useEffect, useState } from "react";
import { Container } from "./style";
import { useApi } from "../../../hooks/api";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";
import { ContentOrLoading } from "../../Loadings/ContentOrLoading";
import { correctDate } from "../../../services/generalServices";
import { maskFunctions } from "../../../services/maskServices";
import { ITable, TableList } from "../../TableList";
import { ActivityTypes, INotificationProps } from "../../../interfaces";
import { getStatus } from "../../../utils/columnsTables";
import { notifications_status } from "../../../utils/reservation_status";

interface IModalReservationsNotificationsProps {
  onCancel: Function;
  defaultId?: string;
  openModal: boolean;
  backgroundVisible?: boolean;
}

const texts: any = {
  title: 'Notificações',
  subTitle: 'Segue abaixo as notificações vinculadas a reserva',
};

const initialTable: ITable = {
  data: [],
  columns: [
    {
      attr: "number",
      name: "Telefone",
      style: {},
      styleContent: { fontSize: 14 },
    },
    {
      attr: "email",
      name: "Email",
      style: {},
      styleContent: { fontSize: 14 },
    },
    {
      attr: "status",
      name: "Status",
      style: { textAlign: 'center' },
      styleContent: { fontSize: 14, textAlign: 'center' },
    },
    {
      attr: "activity",
      name: "Atividade",
      style: {},
      styleContent: { fontSize: 14 },
    },
    {
      attr: "rule_name",
      name: "Regra",
      style: {},
      styleContent: { fontSize: 14 },
    },
    {
      attr: "send_data",
      name: "Data de Envio",
      style: {},
      styleContent: { fontSize: 14 },
    },
  ],
};

export const activity_mapper: { [key: string]: string } = {
  RESERVATION_CREATE: "Reserva Criada",
  RESERVATION_CANCEL: "Reserva Cancelada",
  RESERVATION_PAID: "Reserva Paga",
  CHECKIN_DATE: "Data de Check-in",
  CHECKOUT_DATE: "Data de Check-out",
  CHECKIN_CREATE: "Check-in Criado",
};

export const ModalReservationsNotifications: React.FC<IModalReservationsNotificationsProps> = (props) => {
  const { onCancel, openModal, backgroundVisible, defaultId } = props;

  const { api } = useApi();
  const { theme, notify } = useGlobal();

  const [loading, setLoading] = useState(!!defaultId);

  const [table, setTable] = useState<ITable>(initialTable);

  const searchReservationNotifications = useCallback(async (page) => {
    if (defaultId) {

      setLoading(true);
      try {
        let url = `/notifications?page=${page}&limit=${99}&reservation_id=${defaultId}`;

        const result = await api.get(url);
        const new_notifications = result.data.data as INotificationProps[];
        setTable((atual) => {
          const new_table = { ...atual };
          new_table.data = [];
          new_notifications.forEach((notification) => {
            new_table.data.push({
              id: notification.id,
              number: notification.number ? maskFunctions.phone.mask(notification.number) : null,
              email: notification.email,
              status: getStatus({
                ...notifications_status[notification.status],
                theme,
              }),
              reservation_id: notification.stays_reservation_id,
              activity: activity_mapper[notification.activity as ActivityTypes],
              rule_name: notification.rule_name,
              send_data: correctDate(notification.to_send_date, { month_in_extension: true }),
              this: notification,
            });
          });
          return { ...new_table };
        });

      } catch (err) {
        notify("Erro na busca pelas notificações!", "error");
      }
      setLoading(false);
    }
  }, [defaultId]);

  useEffect(() => {
    searchReservationNotifications(1);
  }, []);

  return (
    <ModalGeneric
      backgroundVisible={backgroundVisible}
      open={openModal}
      onClose={() => { }}
    >
      <Container theme={theme} >
        <ModalHeader
          title={texts.title}
          subTitle={texts.subTitle}
          onCancel={() => onCancel()}
          theme={theme}
        />
        <div style={{ marginBottom: 20 }} />
        <ContentOrLoading type="wave" loading={loading} theme={theme}>
          <div style={{padding: '0 10px 0 10px', overflowY: 'auto', overflowX: 'auto'}}>
            <TableList
              loading={loading}
              text_loading="Buscando Notificações"
              text_empty={"Nenhuma notificação encontrada"}
              table={table}
              noActions
            />
          </div>
        </ContentOrLoading>
      </Container>
    </ModalGeneric>
  );
};
